 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		76: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"pages/Account/Index/pages/Account/Reports/_Year/Index/pages/Admin/Remuneration/Index/pages/Admin/Rem/f49f7fef","1":"pages/Account","2":"pages/Account/Reports/_Year/Index/pages/Admin/Report/Details","3":"pages/Admin/Report/Emails/pages/Admin/Report/Index","4":"pages/Admin/Report/Order/report-payment","5":"pages/Admin/Training/Exam/Index/pages/Admin/Training/Exam/Result","6":"report-documents","7":"vendors/OverlayGallery-OverlayGallery-vue/pages/Index","8":"IconAmex-svg","9":"IconDiscover-svg","10":"IconMasterCard-svg","11":"IconUnknownCreditCard-svg","12":"IconVisa-svg","13":"Overlay-vue","14":"OverlayAddPreviousYear-OverlayAddPreviousYear-vue","15":"OverlayAdminStatus-OverlayAdminStatus-vue","16":"OverlayBasicContent-vue","17":"OverlayBottomCorner-vue","18":"OverlayCookieConsent-OverlayCookieConsent-vue","19":"OverlayEmailForReminder-OverlayEmailForReminder-vue","20":"OverlayGallery-OverlayGallery-vue","21":"OverlayHomeVideo-OverlayHomeVideo-vue","22":"OverlayInfoQuestion-OverlayInfoQuestion-vue","23":"OverlayMessage-OverlayMessage-vue","24":"OverlayMessageYear2020-OverlayMessageYear2020-vue","25":"OverlayMobileMenu-OverlayMobileMenu-vue","26":"OverlayNoticeOfAssessmentAdvice-OverlayNoticeOfAssessmentAdvice-vue","27":"OverlayPrivacySettings-OverlayPrivacySettings-vue","28":"OverlayProceedOrNot-OverlayProceedOrNot-vue","29":"OverlaySurvey-OverlaySurvey-vue","30":"OverlayTermsOfUse-OverlayTermsOfUse-vue","31":"OverlayWriteMessageForm-OverlayWriteMessageForm-vue","32":"account-js","35":"contact-js","36":"ecommerce-js","37":"navigation-js","38":"news-js","39":"pages/404","40":"pages/Account/Index","41":"pages/Account/Referral","42":"pages/Account/Reports/_Year","43":"pages/Account/Reports/_Year/Approve","44":"pages/Account/Reports/_Year/Index","45":"pages/AccountNotConfirmed","46":"pages/Admin","47":"pages/Admin/Index","48":"pages/Admin/Remuneration","49":"pages/Admin/Remuneration/Index","50":"pages/Admin/Remuneration/Slip","51":"pages/Admin/Report","52":"pages/Admin/Report/Details","53":"pages/Admin/Report/Emails","54":"pages/Admin/Report/Index","55":"pages/Admin/Report/Order","56":"pages/Admin/Report/Processing","57":"pages/Admin/Reports/_Filter","58":"pages/Admin/Training","59":"pages/Admin/Training/Category/_Category","60":"pages/Admin/Training/Exam","61":"pages/Admin/Training/Exam/Index","62":"pages/Admin/Training/Exam/Result","63":"pages/Admin/Training/Index","64":"pages/Auth","65":"pages/Contact","66":"pages/Faq","67":"pages/Faq/General","68":"pages/Faq/Index","69":"pages/Faq/Security","70":"pages/Index","71":"pages/Maintenance","72":"report-missing-documents","73":"report-payment","74":"report-relevant-questions","75":"report-tax-expert-message","77":"survey-js","78":"vendors/OverlayGallery-OverlayGallery-vue","79":"vendors/OverlayHomeVideo-OverlayHomeVideo-vue","81":"vendors/pages/Admin/Remuneration/Index"}[chunkId]||chunkId) + "." + {"0":"0a6d251","1":"1b3ca93","2":"8551fa7","3":"6382763","4":"fb2dc76","5":"6d4220b","6":"9a9f04c","7":"5e2d90e","8":"49bd06b","9":"dca885b","10":"e12ce02","11":"1c480eb","12":"ca74707","13":"154e131","14":"4753247","15":"f3078ef","16":"fd2ae07","17":"2908ef1","18":"929d334","19":"5d42003","20":"eaa9bc2","21":"429b66a","22":"9148e86","23":"37e07b0","24":"f4ad50b","25":"421a574","26":"acc5689","27":"4bfdbbe","28":"56791d2","29":"073d3ed","30":"75765f9","31":"2963bce","32":"265d10d","35":"ba4b724","36":"e37f88e","37":"bdb941a","38":"40e63fd","39":"d60f9df","40":"426466c","41":"be9e7c6","42":"a1705d9","43":"eeed127","44":"962565f","45":"98bbd7f","46":"d14f751","47":"7ee2ccc","48":"54c1515","49":"c7a3f0d","50":"29a70bc","51":"8de3762","52":"1faa55c","53":"332dfbb","54":"e17dfb4","55":"3b2eb1f","56":"1cd106a","57":"1f59667","58":"cca3d95","59":"9847986","60":"083c681","61":"d99578c","62":"c60d273","63":"9bf9cac","64":"bcbc44f","65":"fb24a55","66":"47eeed9","67":"6e3db7b","68":"379a34c","69":"8f16a59","70":"0c0e5b5","71":"0fba453","72":"75f68a1","73":"b3d3934","74":"d33315b","75":"b60c034","77":"bfdc910","78":"4e63554","79":"9d2f1f5","81":"d6e6238","82":"7032dae","83":"598f1b0","84":"1506c45"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
